/* global CVP */

// ### WindowWatcher
//
// Observes and reports when a window has been closed.

'use strict';

var _ = require('./vendor/underscore');
var SimpleEmitter = require('./emitter');
var _logger = require('./logger');


function WindowWatcher(id, url, options) {
	this.id = id;
	this.url = url;
	this.options = options;
	this.window = null;
	this.isListening = false;
	this.isExpectedOpen = false;

	this.closeWatcher = _.bind(this.closeWatcher, this);
	this.timer = CVP.Utils.Timing.periodically(this.closeWatcher, 600);

	return SimpleEmitter.mixin(this);
}

WindowWatcher.prototype.isOpened = function () {
	return this.window && !this.window.closed;
};

WindowWatcher.prototype.isClosed = function () {
	return !this.isOpened();
};

WindowWatcher.prototype.setSrc = function (url) {
	if (!this.window) {
		return _logger.warn('setSrc failed: no window!');
	}

	if (this.isClosed()) {
		return _logger.warn('setSrc failed: cannot set location of closed window!');
	}

	this.window.location.href = url;
};

WindowWatcher.prototype.addListeners = function () {
	if (this.isListening || !this.window) {
		return;
	}
	this.isListening = true;
	this.timer.start();
};

WindowWatcher.prototype.removeListeners = function () {
	if (!this.isListening || !this.window) {
		return;
	}
	this.isListening = false;
	this.timer.stop();
};

WindowWatcher.prototype.closeWatcher = function () {
	if (!this.window) {
		_logger.debug('no window found for ID "' + this.id + '"');
		this.removeListeners();
		// don't emit "closed" event as we never had a window
		return;
	}

	if (this.isClosed() && this.isExpectedOpen) {
		_logger.log('window "' + this.id + '" was found closed');
		this.removeListeners();
		this.isExpectedOpen = false;
		this.emit('closed');
	}
};

WindowWatcher.prototype.open = function (url, options) {
	if (this.isOpened() && this.isExpectedOpen) {
		return;
	}

	this.url = url || this.url;
	this.options = options || this.options || '';

	_logger.log('opening window "' + this.id + '" to url "' + this.url + '"');
	this.window = window.open(this.url, this.id, this.options, true);

	this.isExpectedOpen = true;

	this.addListeners();

	this.emit('opened');
};

WindowWatcher.prototype.close = function () {
	if (this.isClosed() && !this.isExpectedOpen) {
		return;
	}

	_logger.log('closing window "' + this.id + '"');

	try {
		this.window.close();
	} catch (e) {
	}

	this.isExpectedOpen = false;

	this.removeListeners();

	this.emit('closed');
};

WindowWatcher.prototype.focus = function () {
	if (!this.isOpened()) {
		return;
	}

	try {
		this.window.focus();
	} catch (e) {
	}
};


module.exports = WindowWatcher;
